import { Typeof } from "utils";

/**
 * Utilities functions.
 *
 * @author Matthieu RENAULT <matthieu.renault@ob-do.com>
 */
class Functions {

  /**
   * Capitalizes the given string.
   * @param {String} string the string to capitalizes
   * @return the capitalized string
   */
  static capitalize(string) {

    if (Typeof.string(string) && string.length > 0) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    return string;
  }

  static formatMacAddress(value) {

    if(Typeof.string(value) && value.length === 12) {
      let groups = value.match(/[0-9A-F]{2}/g);

      if(Typeof.array(groups) && groups.length === 6) {
        return groups.join(':');
      }
    }

    return undefined;
  }

  static formatPhone(value) {

    if(Typeof.string(value)) {
      let groups = value.match(/[0-9]{2}/g);

      if(Typeof.array(groups)) {
        return groups.join(' ');
      }
    }

    return undefined;
  }
}

export default Functions;
